<template>
  <div class="branding">
    <div>
      <div class="container-fluid px-3 px-md-2">
        <ul class="menu d-flex justify-content-center">
          <li><router-link to="/branding" class="py-4">Projects</router-link></li>
          <li><router-link to="/introduction" class="py-4">Introduction</router-link></li>
          <li><router-link to="/services" class="py-4 cur">Services</router-link></li>
        </ul>
      </div>
     
      <div class="content bgA py-5">
        <div class="container-lg px-3 px-md-2">
          <div class="row row-cols-1 row-cols-lg-2 align-items-center">
            <div class="col">
              <div class="l d-flex flex-column align-items-center px-lg-4 px-xxl-5">
                <h4 class="fw-bold mt-4 mt-lg-5 text-uppercase">Branding Services</h4>
              </div>
            </div>
            <div class="col mt-4 mt-lg-0">
              <div class="r px-lg-4 px-xxl-5 lh-lg">
                <div class="d-flex flex justify-content-end">
                  <ul class="ps-4">
                    <li>Visual identity & logotype</li>
                    <li>Brand strategy and development</li>
                    <li>Communication strategy</li>
                    <li>Corporate and brand name</li>
                    <li>Naming systems</li>
                    <li>Signage design</li>
                    <li>Packaging design</li>
                    <li>Sales peripheral design</li>
                    <li>Muti-media design</li>
                    <li>Printed and publication design</li>
                    <li>Commercial architecture</li>
                  </ul>
                </div>
                <div class="d-flex flex justify-content-start mt-4">
                  <ul class="ps-4">
                    <li>Interior design</li>
                    <li>Furniture design</li>
                    <li>Executive plans development</li>
                    <li>Construction management</li>
                    <li>Web design &amp; development</li>
                    <li>Application design &amp; development</li>
                    <li>Information architecture</li>
                    <li>User interphase design ( UI )</li>
                    <li>User experience design ( UX )</li>
                    <li>Usability analysis</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content py-5 zw">
        <div class="container-lg px-3 px-md-2">
          <div class="row row-cols-1 row-cols-lg-2 align-items-center">
            <div class="col order-lg-2">
              <div class="l d-flex flex-column align-items-center px-lg-4 px-xxl-5 block">
                <h4 class="fw-bold mt-4 mt-lg-5 text-uppercase">商業品牌策劃服務</h4>
              </div>
            </div>
            <div class="col mt-4 mt-lg-0 order-lg-1">
              <div class="r px-lg-4 px-xxl-5 lh-lg">
                <div class="d-flex flex justify-content-start">
                  <ul class="pt-4">
                    <li>視覺營銷和商標設計</li>
                    <li>品牌策劃和研發</li>
                    <li>傳銷策略</li>
                    <li>企業和品牌命名</li>
                    <li>命名系統</li>
                    <li>導視設計</li>
                    <li>包裝設計</li>
                    <li>銷售方案</li>
                    <li>多謀體設計</li>
                    <li>印刷版面設計</li>
                    <li>商業建築</li>
                  </ul>
                </div>
                <div class="d-flex flex justify-content-end mt-4">
                  <ul class="pt-4">
                    <li>室內設計</li>
                    <li>家具設計</li>
                    <li>規劃設計</li>
                    <li>項目工程管理</li>
                    <li>網頁設計及策劃</li>
                    <li>應用程序的設計與開發</li>
                    <li>信息架構策劃</li>
                    <li>界面設計 ( UI )</li>
                    <li>用戶體驗設計 ( UX )</li>
                    <li>使用性分析</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Branding',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.l::before{ content: ''; width: 20px; height: 100px; background-color: #cbb778;}
.block::before{ background-color: #0d62af;}
.l p{ color: #999;}
.r{ color: #666;}
.r li{ list-style: disc;}
.zw ul{writing-mode: vertical-rl;}

@media (min-width: 576px) {

}

@media (min-width: 768px) {

}

@media (min-width: 992px) {
  .l::before{ height: 150px;}
}

@media (min-width: 1200px) {

}

@media (min-width: 1400px) {
}
</style>



// WEBPACK FOOTER //
// src/components/branding/Services.vue